import React, { useState } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { UserPearl } from '@galop/component-library';
import Can from './Can';
import { AppName } from '../../App';

export const NavMenu = (props) => {
    const [collapsed, setCollapsed] = useState(true);
    const activePath = window.location.pathname;
    const paths = {
        home: "/admin",
        embed: "/admin/embed",
        inquiries: "/admin/inquiries",
        properties: "/admin/properties",
        topics: "/admin/topics",
        users: "/admin/users",
        reports: "/admin/reports"
    };

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    return (
        <header className="d-block" /*className="sticky-top"*/>
            <Navbar expand="md" className="bg-off-white" light>
                <NavbarBrand tag={Link} to="/">{AppName}</NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="order-md-2 ms-auto me-2 border-0" />
                <Can perform=""
                    yes={() => <UserPearl className="order-md-3" CurrentUser={props.CurrentUser} />} />
                {props.CurrentUser ?
                    <Collapse className="order-md-1" isOpen={!collapsed} navbar>
                        <ul className="navbar-nav flex-grow">
                            <Can role=""
                                yes={() => <NavItem>
                                    <NavLink tag={Link} className="" to={paths.home} onClick={() => setCollapsed(true)} active={activePath === paths.home}>Home</NavLink>
                                </NavItem>
                                } />
                            <Can role="admin"
                                yes={() => <NavItem>
                                    <NavLink tag={Link} className="" to={paths.embed} onClick={() => setCollapsed(true)} active={activePath === paths.embed}>Embedded Form</NavLink>
                                </NavItem>
                                } />
                            <Can role="admin"
                                yes={() => <NavItem>
                                    <NavLink tag={Link} className="" to={paths.inquiries} onClick={() => setCollapsed(true)} active={activePath === paths.inquiries}>Inquiries</NavLink>
                                </NavItem>
                                } />
                            <Can perform=""
                                yes={() => {
                                    return (<NavItem>
                                        <UncontrolledDropdown>
                                            <DropdownToggle nav caret className={`${activePath === paths.properties  || activePath === paths.users ? 'active': null}`}>Manage</DropdownToggle>
                                            <DropdownMenu>
                                                {/*<DropdownItem header className="d-none d-md-inline-block border-bottom">Manage</DropdownItem>*/}
                                                <Can role=""
                                                    yes={() => <DropdownItem tag={Link} className="" to={paths.properties} onClick={() => setCollapsed(true)} active={activePath === paths.properties}>Properties</DropdownItem>
                                                    } />
                                                <Can role=""
                                                    yes={() => <DropdownItem tag={Link} className="" to={paths.topics} onClick={() => setCollapsed(true)} active={activePath === paths.topics}>Topics</DropdownItem>
                                                    } />
                                                <Can role=""
                                                    yes={() => <DropdownItem tag={Link} className="" to={paths.users} onClick={() => setCollapsed(true)} active={activePath === paths.users}>Users</DropdownItem>
                                                    } />
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </NavItem>);
                                }} />
                            <Can role="admin"
                                yes={() => <NavItem>
                                    <NavLink tag={Link} className="" to={paths.reports} onClick={() => setCollapsed(true)} active={activePath === paths.reports}>Report</NavLink>
                                </NavItem>
                                } />
                        </ul>
                    </Collapse>
                    : null}
            </Navbar>
        </header>
    );
};
/*                                <Can perform=""
                                    yes={() => <UncontrolledDropdown>
                                        <DropdownToggle nav caret />
                                        <DropdownMenu>
                                            <DropdownItem header className="d-none d-md-inline-block border-bottom">Ancillary Lists</DropdownItem>
                                            <Can perform="Regionals"
                                                yes={() => <DropdownItem>
                                                    <NavLink tag={Link} className="" to="/regionals" onClick={() => setCollapsed(true)}>Regionals</NavLink>
                                                </DropdownItem>
                                                } />
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                    } />
*/


// WEBPACK FOOTER //
// ./src/components/Shared/NavMenu.js